import React from 'react';
import { Helmet } from 'react-helmet';
import Fall from '@components/fall/Fall';
import Footer from '@components/footer/Footer';
import Header from '@components/header/header';
import Main from '@components/main/main';
import appsData from '@data/appsdata.yml';
import { AppData } from 'models/home';
import './index.scss';

const IndexPage = () => {
  const { apps } = appsData as { apps: AppData[] };
  return (
    <div>
      <Helmet>
        <title>Funtory</title>
      </Helmet>

      <Header />
      <main>
        <Main />

        <div id="GAMES">
          {apps.map((app, i) => (
            <Fall appData={app} reversed={i % 2 === 0} key={i} />
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default IndexPage;
